<template>
  <div>
    <el-dialog width="960px" title="查看详情" :visible.sync="dialogFormVisible" showClose append-to-body center>
      <div class="dialog-info-box">
        <Video :imgUrl="insideData.posterH?insideData.posterH:''" isProgram="programs" />
        <ItemInfo :goEdit="false"  v-if="insideData" :insideData="insideData"/>
      </div>
      <el-row type="flex" justify="center">
        <el-button @click="dialogVisible = true">不通过</el-button>
        <el-button type="primary" @click="handleSubmitPass">通过</el-button>
      </el-row>
    </el-dialog>
    <el-dialog title="不通过原因" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <el-input type="textarea" v-model="unpassDesc" :rows="5" maxlength="100" show-word-limit placeholder="请输入100以内的字符内容"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmitUnpass">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Video from '@/components/Video'
import ItemInfo from '@/components/ItemInfo'
import { sendPrograms } from '@/resource/api/program-group-management'

export default {
  props: ['insideData', 'approved', 'unApproved'],
  components: {
    ItemInfo,
    Video
  },
  data () {
    return {
      dialogFormVisible: false,
      dialogVisible: false,
      unpassDesc: ''
    }
  },
  methods: {
    openDialog () {
      this.dialogFormVisible = true
    },
    // 节目集送审
    fetchSendPrograms (isPass, data) {
      sendPrograms(data).then((res) => {
        if (res.code == '1') {
          this.dialogFormVisible = false
          this.dialogVisible = false
          this.$message({
            type: 'success',
            message: isPass == 1 ? '审核通过' : '审核不通过'
          })
          this.$emit('addSuccess')
        } else {
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      })
    },
    // 通过
    handleSubmitPass () {
      this.$confirm('你确定要通过选中的内容吗?', '通过审核', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const data = {
          auditState: this.approved,
          memo: '',
          id: this.insideData.id,
          operator: this.$store.state.router.updateBySuffix
        }
        this.fetchSendPrograms(1, data)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    // 不通过确定
    handleSubmitUnpass () {
      if (this.unpassDesc) {
        const data = {
          auditState: this.unApproved,
          memo: this.unpassDesc,
          id: this.insideData.id,
          operator: this.$store.state.router.updateBySuffix
        }
        this.fetchSendPrograms(2, data)
        this.unpassDesc = ''
      } else {
        this.$message({
          type: 'error',
          message: '请输入不通过原因'
        })
      }
    },
    handleClose () {
      this.dialogVisible = false
      this.unpassDesc = ''
    }
  }
}
</script>
